import { post, API } from '../../net/http';
import _ from 'lodash';
export default {
  namespaced: true,
  state: {
    insurances: [],
    localeOrder: {},
    sendInfo: null,
    bindFedexLoading: false,
    bindedFedex: true,
    states: [],
    isChange: false,
  },
  mutations: {
    clearOrder(state) {
      state.sendInfo = null;
    },
    setOrder(state, order) {
      this.bindedFedex = order.status !== 'DRAFT';
      state.sendInfo = order;
    },
    setStoreOrder(state, body) {
      if (body) {
        let { key, val } = body;
        state.localeOrder[key] = val;
      } else {
        state.localeOrder = {};
      }
    },
    clearLocaleOrder(state) {
      state.localeOrder = null;
    },
    updateChange(state, isChange) {
      state.isChange = isChange;
    },
  },
  actions: {
    getInsurance(content) {
      let { state, commit, rootGetters } = content;
      let insurances = _.get(rootGetters, 'app.insurances', []);
      if (insurances.length > 0) {
        state.insurances = insurances;
        return Promise.resolve(insurances);
      }
      return post(API.priceInsurance).then(res => {
        if (res.success) {
          let insurances = res.data;
          state.insurances = insurances;
          commit(
            'app/setAppConfig',
            {
              key: 'insurances',
              val: insurances,
            },
            { root: true },
          );
          return insurances;
        }
        return [];
      });
    },
    getPickUpPrice() {
      return post(API.pricePickup);
    },
    saveOrder2serverAndLocle({ state }, body) {
      state.saveOrder = body;
      let api = body.orderNum ? API.orderEdit : API.orderSave;
      return post(api, body);
    },
    getPickUpTimeRange(content, body) {
      return post(API.pickupListAval, body);
    },
    getStates({ state }) {
      if (state.states.length > 0) {
        return Promise.resolve(state.states);
      }
      return post(API.getState).then(res => {
        if (res.success) {
          let rdata = res.data;
          res.data = Object.keys(rdata).map(key => {
            return {
              key: key,
              value: rdata[key],
            };
          });
          state.states = res;
        }
        return res;
      });
    },
    fetchOrderMainInfo({ state }, orderNum) {
      return post(API.orderMainInfo, {
        orderNum: orderNum,
      }).then(res => {
        if (res.success) {
          state.sendInfo = res.data;
        }
        return res;
      });
    },
    fetchOrderMainDraftInfo({ state }, orderNum) {
      state.bindFedexLoading = true;
      if (orderNum || state.sendInfo) {
        orderNum = orderNum || state.sendInfo.orderNum;
        return post(API.orderMainDraftInfo, {
          orderNum: orderNum,
        })
          .then(res => {
            state.bindFedexLoading = false;
            if (res.success) {
              state.sendInfo = res.data;
              state.bindedFedex = res.data.status !== 'DRAFT';
            }
            return res;
          })
          .catch(e => {
            state.bindFedexLoading = false;
            return e;
          });
      }
    },
    orderBackSave(content, body) {
      return post(API.orderBackSave, body);
    },
    orderBackEdit(content, body) {
      return post(API.orderBackEdit, body);
    },
    orderBackUpdate(content, body) {
      return post(API.orderBackUpdate, body);
    },
    getReturnPrice() {
      return post(API.priceSignatureType);
    },
    getReturnDate(content, body) {
      return post(API.orderBackDeliveryDate, body);
    },
    getSendDate(content, body) {
      return post(API.orderBackSendDate, body);
    },
  },
};
